import React, { Component } from "react";
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import * as wActs from '../actions/website-actions';
import {FormattedMessage} from "react-intl";
import CountrySelect from "./countryselect";

class Header extends Component {

  constructor(props) {
    super(props);
    this.state = {
      mobileMenuOpen: false,
      searchTxt: ""
    };
    this.showLogin = this.showLogin.bind(this);

  }

  showLogin() {
    this.props.dispatch(wActs.showLogin());
  }

  toggleMenu(e) {
    e.preventDefault();

    if (this.state.mobileMenuOpen) {
      //document.documentElement.classList.remove("no-scroll");
      this.setState({mobileMenuOpen: false});
    } else {
      //document.documentElement.classList.add("no-scroll");
      this.setState({mobileMenuOpen: true});
    }
  }

  handleKeyPress(event) {
    if(event.key === 'Enter'){
      event.preventDefault();
      this.props.history.push(wActs.getCultPath(this.props.WebPage,"/search?term=" + escape(this.state.searchTxt)));
      this.handleSideMenuClick();
      //this.props.dispatch(pActs.searchProfiles(this.state.searchTxt));
      return;
    }
  }

  handleClick() {
    eval("$('body').toggleClass('menu-open')");
  }

  handleChange(event) {
    this.setState({searchTxt: event.target.value})
  }

  handleSearchButton(event) {
    event.preventDefault();
    this.props.history.push(wActs.getCultPath(this.props.WebPage,"/search?term=" + escape(this.state.searchTxt)));
    this.handleSideMenuClick();
  }

  searchProfiles() {

  }


  doTicketLogin(url) {
    let auth = localStorage.getItem("siteways-bearer");
    let authD = null; let bearer = "";
    if (!wActs.isNullOrEmpty(auth)) {
      authD = JSON.parse(auth);
      bearer = authD.access_token;
    } else {
      this.props.dispatch(wActs.showWarning("ERROR", this.getTranslation("response.failed")));
    }

    fetch(`/auth/createticket`, {
      headers: {
        'X-Alt-Referer': window.location.toString(),
        'Content-type': 'application/x-www-form-urlencoded'
      },
      method: 'POST',
      body: `bear=${encodeURIComponent(bearer)}`
    })
      .then(resp => resp.json())
      .then(function (data) {
        if (data.Code == 200) {
          window.location = url + "?ticket=" + encodeURIComponent(data.Result);
        }
      }).catch((err) => {
        console.log("Failed to set DASH cookie...", err);
        this.props.dispatch(wActs.showWarning("ERROR", this.getTranslation("response.failed")));
      }).finally(() => {
      });
  }

  gotoDashUrl() {
    try {
      let dUrl = `https://me.` + wActs.getSubdomain(this.props.WebPage.Settings.DashUrl);
      let chost = new URL(this.props.WebPage.ServerParams.Referer).hostname;
      let dhost = new URL(dUrl).hostname;

      this.doTicketLogin(dUrl); return;
      /*  
      chost = wActs.getSubdomain(chost); dhost = wActs.getSubdomain(dhost);
      let allowDomains = [
        "topescort.nl",
      ];
      if (dhost !== chost && !this.inArray(allowDomains, chost)) {
        this.getLoginKey((res) => {
          if (res.Code == 200) {
            let key = res.Result;
            let url = this.props.WebPage.Settings.DashUrl + `/api/loginpass?key=${key}`;
            window.open(url);
          } else {
            window.open(this.props.WebPage.Settings.DashUrl);
          }
        });
      
      } else {
        window.open(this.props.WebPage.Settings.DashUrl);
      }
      */
    } catch (ex) {
      console.log("Error In getDashUrl: " + ex.message);
      window.open(this.props.WebPage.Settings.DashUrl);
    }
  }



  domainLogo() {
    let ref = this.props.ServerParams.Referer;
    if (typeof ref === "undefined") {
      ref = "https://stage.redlight.nl:3000/";
    }
    let domain = ref.replace("https://").replace("http://").split("/")[0];
    domain = domain.split(":")[0];
    domain = domain === "localhost" || domain.startsWith('10.') ? "www.redlight.nl" : domain;
    let name = "";
    let prts = domain.split(".");
    name = prts[prts.length-2];
    return ( <img src={`/imgs/${name}.svg`} alt={this.props.WebPage.Settings.SeoName}/> );
  }

  handleLogout(e) {
    e.preventDefault();
    //localStorage.removeItem('siteways-bearer');
    wActs.removeCookie("auth");
    window.location.reload();
  }

  handleSideMenuClick() {
    //document.documentElement.classList.remove("no-scroll");
    this.setState({mobileMenuOpen: false});
    //window.HideSideMenu();
  }

  handleSeoClick(e) {
    e.preventDefault();
    //this.props.dispatch(wActs.LoadPageSeo());
  }
  handleSettingsClick(e) {
    e.preventDefault();
    window.open(`${this.props.WebPage.Settings.DashUrl}/domain?ref=${escape(window.location.href)}`)
    //this.props.dispatch(wActs.LoadPageSeo());
  }

  getTranslation(key, def) {
    return wActs.isNullOrUndefined(this.props.WebPage.Translations[key]) ? def : this.props.WebPage.Translations[key];
  }

  hasRole(role) {
    let hasRole = false;
    let user = this.props.WebPage.User;
    if(!wActs.isNullOrUndefined(user.Roles) && user.Roles.length) {
      user.Roles.map((v) => {
        if(v === role) {
          hasRole = true;
        }
      })
    }
    return hasRole;
  }


  selectedLocale() {
    let loc = this.props.WebPage
  }

  getTerm() {
    let url = "";
    if(typeof window !== "undefined") {
      url = window.location.href;
    } else {
      url = "https://www.fakeurl.com" + this.props.WebPage.ServerParams.Query;
    }
    return wActs.getParameterByName("term", url, "");
  }

  render() {
    let hLink = wActs.getCultPath(this.props.WebPage,"/");
    if(hLink.endsWith("/")) { hLink = hLink.substr(0,hLink.length -1)}
    let term = this.getTerm();
    return (
      <header id="header" className={this.props.PageType == "home" ? "hp" : "inner"}>
        <div className="top">
          <div className="container">
            <div className="cell x12">
              <ul>
                <li><strong>{this.getTranslation("page.escortdude.home.escortnetwork", "Network")}</strong>:</li>
                {!wActs.isNullOrUndefined(this.props.WebPage.Menu.Other) &&
                  <React.Fragment>
                    {this.props.WebPage.Menu.Other[0].Menu.map((v,i) => {
                        if(v.Page) {
                          return <li key={"mnuli" + i}><Link className={this.props.WebPage.Settings.LocalCSS} key={"mnu" + i} to={v.Page.Path} title={v.Description}>{v.Title}</Link></li>;
                        } else {
                          if(v.Settings) {
                            return <li key={"mnuli" + i}><a className={this.props.WebPage.Settings.LocalCSS} key={"mnu" + i} href={v.Settings.Url} target="_blank" title={v.Description}>{v.Title}</a></li>;
                          }
                        }
                    })}
                  </React.Fragment>
                }
              </ul>
            </div>
            <div className="clear"></div>
          </div>
        </div>

        <div className="header">
          <div className="container">
            <div className="header-wrap">
              <div className="logo">
                <Link to={wActs.getCultPath(this.props.WebPage,"/")}><img src={this.props.WebPage.Settings.LogoUrl} alt={this.props.WebPage.Settings.SeoName}/></Link>
              </div>
              <div className="header-menu">
                <ul>
                  {this.props.WebPage.User.UserId<=0 &&
                    <React.Fragment>
                      <li className="w-sep light-color"><Link to={wActs.getCultPath(this.props.WebPage,"/login")}>{this.getTranslation("page.submitlink", "Submit A Link")}</Link></li>
                      <li className="simple"><Link to={wActs.getCultPath(this.props.WebPage,"/login")}>{this.getTranslation("page.header.login")}</Link></li>
                      <li className="dark-color"><Link to={wActs.getCultPath(this.props.WebPage,"/signup")}>{this.getTranslation("page.header.signup")}</Link></li>
                    </React.Fragment>
                  }
                  {this.props.WebPage.User.UserId>0 &&
                    <React.Fragment>
                      <li className="w-sep light-color"><Link to={wActs.getCultPath(this.props.WebPage,"/submit-link")}>{this.getTranslation("page.submitlink")}</Link></li>
                      <li className="simple"><a href={"#"} onClick={(e)=>{this.handleLogout(e)}}>{this.getTranslation("menu.logout")}</a></li>
                    <li className="dark-color"><a href="javascript:;" onClick={() => { this.gotoDashUrl(); }}>{this.getTranslation("menu.myaccount")}</a></li>
                    </React.Fragment>
                  }

                </ul>
                <div className="switch-lang">
                  <div className="current-lang">
                    <CountrySelect/>
                  </div>
                </div>
              </div>
              <div className="burger">
                <div className="switch-lang">
                  <div className="current-lang">
                    <CountrySelect/>
                  </div>
                </div>
                <a href="#menu-open" className="menu-toggle">
                  <span className="button-menu-line button-menu-line--1"></span>
                  <span className="button-menu-line button-menu-line--2"></span>
                  <span className="button-menu-line button-menu-line--3"></span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div id="menu-open" className="menu-overlay">
          <div className="mobile-overlay"></div>
          <div className="menu-content">
            <div className="menu-logo">
              <Link to={wActs.getCultPath(this.props.WebPage,"/")}><img src={this.props.WebPage.Settings.LogoUrl} alt={this.props.WebPage.Settings.SeoName}/></Link>
            </div>
            <nav className="mobile-menu">
              <ul>
                {this.props.WebPage.Menu.Footer.map((v,i) => {
                  if(v.Page) {
                    return <li key={"mnuli" + i} onClick={(e) => { this.handleClick(e) }}><Link className={this.props.WebPage.Settings.LocalCSS} key={"mnu" + i} to={v.Page.Path} title={v.Description}>{v.Title}</Link></li>;
                  } else {
                    if(v.Settings) {
                      return <li key={"mnuli" + i} onClick={(e) => { this.handleClick(e) }}><a className={this.props.WebPage.Settings.LocalCSS} key={"mnu" + i} href={v.Settings.Url} target="_blank" title={v.Description}>{v.Title}</a></li>;
                    }
                  }
                })}
                <li onClick={(e) => { this.handleClick(e); }}><Link to={wActs.getCultPath(this.props.WebPage,"/submit-link")} className={this.props.WebPage.Settings.LocalCSS} key={"mnu-signup"}>{this.getTranslation("page.header.signup").toLocaleUpperCase()}</Link></li>
                {this.props.WebPage.User.UserId>0 &&
                  <React.Fragment>
                    <li onClick={(e) => { this.handleLogout(e); }}><a href={"#"} className={this.props.WebPage.Settings.LocalCSS} key={"mnu-logout"}>{this.getTranslation("menu.logout").toLocaleUpperCase()}</a></li>
                    <li onClick={(e) => { this.handleClick(e); }}><Link to={wActs.getCultPath(this.props.WebPage,"/submit-link")} className={this.props.WebPage.Settings.LocalCSS} key={"mnu-submit"}>{this.getTranslation("page.submitlink", "Submit A Link").toLocaleUpperCase()}</Link></li>
                  </React.Fragment>
                }
                {this.props.WebPage.User.UserId<=0 &&
                  <React.Fragment>
                    <li onClick={(e) => { this.handleClick(e); }}><Link to={wActs.getCultPath(this.props.WebPage,"/login")} className={this.props.WebPage.Settings.LocalCSS} key={"mnu-login"}>{this.getTranslation("page.header.login").toLocaleUpperCase()}</Link></li>
                    <li onClick={(e) => { this.handleClick(e); }}><Link to={wActs.getCultPath(this.props.WebPage,"/login")} className={this.props.WebPage.Settings.LocalCSS} key={"mnu-submit"}>{this.getTranslation("page.submitlink", "Submit A Link").toLocaleUpperCase()}</Link></li>
                  </React.Fragment>
                }

              </ul>
            </nav>
          </div>
        </div>

      </header>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    ServerParams: state.Website.ServerParams,
    PageType: state.Website.PageType
  };
}

export default withRouter(connect(mapStateToProps)(Header));
